import {DynamicElement} from './DynamicElement';

export class OptionDependency {
  public questionId: number = 0;
  public optionId: string = '';
  public element!: DynamicElement;

  constructor(data: any) {
    this.optionId = data.optionId;
    this.questionId = data.questionId;
  }

  public toString(): string {
    return `OptionDependency<${this.optionId},${this.questionId}>`;
  }
}
